<template>
  <div class="content">
    <h3 class="header-title">店铺收藏</h3>
    <div class="wrapper" v-loading="loading">
      <div class="store-list" v-if="storeList.length">
        <div class="store-card" v-for="(item, index) in storeList" :key="item.bxmId">
          <el-row>
            <el-col :span="6">
              <router-link
                tag="div"
                :to="`/shopStore?storeId=${item.bxmId}`"
                class="store-info clearfix">
                <el-image class="store-logo" :src="item.logo" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="info-list">
                  <div class="name">{{ item.name }}</div>
                  <div class="address">
                    <span class="gray-text">店铺地址：</span>{{ item.address }}
                  </div>
                  <div class="sort">
                    <span class="gray-text">店铺类型：</span>{{ item.sortname }}
                  </div>
                  <el-button
                    size="mini" plain @click.stop="toggleCollect(item, index)"
                    icon="el-icon-star-on">取消关注</el-button>
                </div>
              </router-link>
            </el-col>
            <el-col :span="18">
              <div class="store-goods-wrap">
                <router-link
                  tag="div"
                  class="trigger"
                  :to="`/shopStore?storeId=${item.bxmId}`">更多商品
                </router-link>
                <div class="store-goods">
                  <div  @click="$tools.showGoodInBlank(good.id)"
                    class="good-item"
                    v-for="good in item.goods"
                    :key="good.id">
                    <el-image class="good-cover" :src="good.photos" fit="contain">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <div class="good-name OneLineDisplay">{{ good.name }}</div>
                    <div class="good-price-count">
                      <span class="price">{{ good.price | decimal }}</span>
                      <span class="count gray-text">已售{{ item.saleNum || 0 }}件</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageNum }" @callFather="handlePageChange"></Pagination>
      </div>
      <empty v-else>暂无收藏店铺</empty>
    </div>
  </div>
</template>
<script>
import {collection_list, removeCollection} from "@/api/xunyou";
import Pagination from '@/components/Pagination';
export default {
  data() {
    return {
      loading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      storeList: []
    };
  },
  components: {Pagination},
  created() {
    this.getCollectionStore();
  },
  methods: {
    // 切换收藏状态
    toggleCollect(store, index) {
      const params = {
        type: 2, // 1:商品；2：店铺；必填
        uid: this.$store.getters.userId,
        cid: store.bxmId
      }
      removeCollection(params).then(res => {
        console.log('收藏结果：', res);
        if (res.code === 0) {
          this.storeList.splice(index, 1);
          this.$message.success('已移除');
        }
      }).catch(err => {
        this.$message.error("操作失败，请稍后再试！");
      });
    },
    // 翻页
    handlePageChange (val) {
      this.pageSize = val.pageSize;
      this.pageNum = val.currentPage;
      this.getCollectionStore();
    },
    getCollectionStore() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 2, //type:1:商品；2：店铺
        uid: this.$store.getters.userId
      }
      this.loading = true;
      collection_list(params).then((res) => {
        console.log('收藏商品：', res);
        this.loading = false;
        if (res.code === 0) {
          this.total = res.total;
          this.storeList = res.rows.map(ele => ele.merchant);
        } else {
          this.$message.error(res.msg);
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("收藏商品查询失败，请稍后再试！");
      });
    }
  }
};
</script>

<style scoped lang="less">
.header-title{
  font-size: 20px;
  color: #666;
}
.store-list{
  padding: 10px 0;
}
.store-card {
  padding: 15px;
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(187, 187, 187, 0.2);

  .gray-text {
    color: #888888;
  }

  .store-logo {
    float: left;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  .info-list {
    padding-left: 80px;

    .name {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .sort {
      margin-bottom: 20px;
    }
  }

  .store-goods-wrap {
    position: relative;

    .trigger {
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 10;
      writing-mode: vertical-lr;
      padding: 0 10px;
      letter-spacing: 5px;
      text-align: center;
      background: linear-gradient(90deg, #f9f9f9, #fffffffc);
      cursor: pointer;
    }
  }

  .store-goods {
    position: relative;
    height: 172px;
    white-space: nowrap;
    overflow-x: auto;
    padding: 10px 0;
    box-sizing: border-box;
    border-left: 1px dashed #edefdd;
  }

  .good-item {
    display: inline-block;
    box-shadow: 0px 0px 10px rgba(172, 172, 172, 0.2);
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;

    .good-cover {
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }

    .good-name {
      max-width: 100px;
    }

    .good-price-count {
      line-height: 1;
      margin-top: 5px;

      .price {
        color: var(--main-theme-color);
        font-size: 14px;
        float: left;

        &:before {
          content: "￥";
          font-size: 12px;
        }
      }

      .count {
        float: right;
      }
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/views/myOrder/attentionCenter/shopCollection.vue